import { withState } from 'recompose';

export default withState('expand', 'updateExpand', {});
